import { render, staticRenderFns } from "./CreateCommentModal.vue?vue&type=template&id=59ca2f44&scoped=true&"
import script from "./CreateCommentModal.vue?vue&type=script&lang=js&"
export * from "./CreateCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCommentModal.vue?vue&type=style&index=0&id=59ca2f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca2f44",
  null
  
)

export default component.exports